import { Grid, Paper, Stack, TextField, Typography } from "@mui/material";
import React from "react";
import Editor from "react-simple-code-editor";
import { highlight, languages } from 'prismjs/components/prism-core';
// import 'prismjs/components/prism-javascript';

import Service from "../../../../util/Service";
const BmcAnexoBusinessTask = React.forwardRef((props, ref) => {
    const { item, processo } = props;

    const [code, setCode] = React.useState('');
    React.useImperativeHandle(ref, ()=> ({
        childMethod() {
            salva();
          }
    }))

    React.useEffect(()=>{
        const tk = processo.lstTask.find( t => t.idTask === item.id);
        console.log(1);
        if( tk ){
            setCode( tk.code ?tk.code: '' );
        }else{
            buscaCodigo('BmcAnexo.txt');
        }
    },[]);
    function buscaCodigo(exemplo){
        if( !exemplo) return;
        Service.FETCH("/api/bpmn/buscaCodigoExemplo/"+exemplo) 
        .then(r => {
            setCode(r)
        });
    };

    function salva(){
        console.log('>>>salva from Filho<<<');

        const dado = {
            idTask: item.id,
            idProcesso: processo.id,
            taskType: item.type,   
            tipo: 'BMC-ANEXO',
            code: code,
            
        }

        Service.POST("/api/bpmn/salvarTaskDoProcesso", dado).then(resp => {
            console.log( resp );    
        }).catch(error => {
            console.error(error)
        })
        console.log( dado );
    }
    return (
        <Grid container spacing={2}>
            <Grid size={6}>
                <Stack spacing={2}>
                    <Typography>Fluxo de pos-criação do WO no BMC, busca os arquivos para serem anexados no WO. </Typography>
                </Stack>
            </Grid>
            <Grid size={12}>
            <Paper>
                <Editor
                    value={code}
                    onValueChange={t => setCode(t)}
                    highlight={code => {
                        return highlight(code, languages.js)
                    }}
                    padding={10}
                    style={{
                        fontFamily: '"Fira code", "Fira Mono", monospace',
                        fontSize: 12,
                        minHeight: '400px'
                    }}
                />
            </Paper>
            </Grid>
            
            
        </Grid>
    )

})

export default BmcAnexoBusinessTask;